export const handleLevel1IndexClick = (id: any, navigate: any) => {
  if (id !== Number(localStorage.clickedId)) {
    localStorage.setItem("sitesTablePage", "0");
  }
  localStorage.setItem(
    "storedSelectedIndex",
    JSON.stringify({
      level1: "",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      level6: "",
    })
  );
  localStorage.setItem("siteAboutScrollTop", "0");
  localStorage.setItem("expandedObjectSaved", "false");
  localStorage.setItem("navigatedFromSitesAboutPage", "true");
  localStorage.setItem("clickedId", JSON.stringify(id));
  localStorage.setItem("level1Click", "true");
  localStorage.setItem("level1Id", JSON.stringify(id));
  navigate("/sites");
};
